import { useQuery } from '@tanstack/react-query';
import CourseService from '../Services/courses/CourseService';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';
export const GET_COURSES_QUERY_KEY = 'getCourses';
export const GET_EDUCATIONAL_LEVELS_QUERY_KEY = 'getEducationalLevels';
export const SHOW_COURSE_DETAILS_QUERY_KEY = 'showCourseDetails';
export const GET_CATEGORIES_QUERY_KEY = 'getCategories';
export const GET_COURSES_BY_EDUCATIONAL_LEVEL_QUERY_KEY = 'getCoursesByEducationalLevel';
export const useGetCourses = () => {
  return useQuery({
    queryKey: [GET_COURSES_QUERY_KEY],
    queryFn: CourseService.listAllCourses,
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 10 * 60 * 60 * 1000, // 10 hours
    refetchOnWindowFocus: false, // Prevent refetch when window regains focus
    refetchOnMount: false, // Use cached data when component remounts
  });
};
export const useGetCoursesByUserEducationalLevel = (enabled) => {
  return useQuery({
    queryKey: [GET_COURSES_BY_EDUCATIONAL_LEVEL_QUERY_KEY],
    queryFn: CourseService.getCoursesByUserEducationalLevel,
    enabled: !!enabled, // Ensure enabled is a boolean
    staleTime: 24 * 60 * 60 * 1000, // 24 hours
    cacheTime: 48 * 60 * 60 * 1000, // 48 hours
    refetchOnWindowFocus: false, // Prevent refetch when window regains focus
    refetchOnMount: false, // Use cached data when component remounts
  });
};

export const useGetEducationalLevels = () => {
  return useQuery({
    queryKey: [GET_EDUCATIONAL_LEVELS_QUERY_KEY],
    queryFn: CourseService.getAllEducationalLevels,
    staleTime: 24 * 60 * 60 * 1000, // 24 hours
    cacheTime: 48 * 60 * 60 * 1000, // 48 hours
    // enabled,
  });
};

export const useShowCourseDetails = (id) => {
  const navigate = useNavigate();
  
  return useQuery({
    queryKey: [SHOW_COURSE_DETAILS_QUERY_KEY, id],
    queryFn: async () => {
      try {
        return await CourseService.showCourseDetails(id);
      } catch (error) {
        // Handle the error here in the queryFn instead of onError
        // console.log('Error caught in queryFn:', error);
        
        const status = error?.response?.status || error?.status;
        const message = error?.response?.data?.message || error?.message;
        
        if (status === 403) {
          // Check the specific error message for educational level mismatch
          if (message?.includes('different educational level')) {
            toast.warning("Vous n'avez pas accès à ce cours. Il appartient à un autre niveau éducatif.", {
              duration: 3000,
            });
            setTimeout(() => navigate('/app/courses'), 1500); // Small delay to show toast
          } else if (message?.includes('Educational level not set')) {
            toast.warning("Niveau éducatif non défini pour votre compte.", {
              duration: 3000,
            });
            setTimeout(() => navigate('/app/courses'), 1500);
          } else {
            toast.error("Accès non autorisé à ce contenu.", {
              duration: 3000,
            });
            setTimeout(() => navigate('/app/home'), 1500);
          }
        }
        
        // Re-throw the error so React Query knows it failed
        throw error;
      }
    },
    retry: (failureCount, error) => {
      // Don't retry on 403 errors
      const status = error?.response?.status || error?.status;
      if (status === 403) {
        return false;
      }
      return failureCount < 2; // Retry other errors twice
    },
    // Improved caching configuration to prevent unnecessary refetches
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 60 * 60 * 1000, // 1 hour
    refetchOnWindowFocus: false, // Prevent refetch when window regains focus
    refetchOnMount: false, // Use cached data when component remounts
  });
};

export const useGetCategories = (enabled = true) => {
  return useQuery({
    queryKey: [GET_CATEGORIES_QUERY_KEY],
    queryFn: CourseService.getAllCategories,
    staleTime: 24 * 60 * 60 * 1000, // 24 hours
    cacheTime: 48 * 60 * 60 * 1000, // 48 hours
    enabled,
  });
};